import { State } from "./state";
import Mutations from "./mutations";
import Getters from "./getters";
import Actions from "./actions";
import Item from "@/store/Abstract/Item";
export default class DrivingSchool {
    namespaced = true;
    state;
    mutations = Mutations;
    getters = Getters;
    actions = Actions;
    modules;
    constructor() {
        this.state = new State();
        this.modules = {
            links: new Item(),
        };
    }
}
